module.exports.Directive = function() {
  return {
    restrict: "E",
    scope: {},
    templateUrl: "/modules/admin/dashboard/dashboard.view.html"
  };
};
